export default __webpack_public_path__ + "static/media/ag-dropdown.7126e81c.webp";